export default () => {
    return useCookie<object | null>('pilulkaCookieSettings', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
